import { render, staticRenderFns } from "./cardChatResidente.vue?vue&type=template&id=fb73c564"
import script from "./cardChatResidente.vue?vue&type=script&lang=js"
export * from "./cardChatResidente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports